import React from "react";
import styled from "styled-components";

import {
  TECHNOLOGY_ICON_HEIGHT,
  TECHNOLOGY_ICON_SRC,
} from "./technologyIcons";

const IconWrapper = styled.div`
  height: ${TECHNOLOGY_ICON_HEIGHT}px;
  width: ${TECHNOLOGY_ICON_HEIGHT}px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  && img {
    height: ${TECHNOLOGY_ICON_HEIGHT}px;
    width: auto;
    max-width: 100%;
    margin: 0;
    display: block;
  }
`;

const TechnologyIcon = ({ name }) => {
  const src = TECHNOLOGY_ICON_SRC[name];

  if (!src) {
    return null;
  }

  return (
    <IconWrapper>
      <img src={src} alt={name} height={TECHNOLOGY_ICON_HEIGHT} />
    </IconWrapper>
  );
};

export default TechnologyIcon;
